import { Grid } from "@mui/material";
import React from "react";
import LeaveAdminHeader from "./home/header";
import LeaveAdminTabel from "./home/table";

const LeaveAdmin = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <LeaveAdminHeader />
      </Grid>
      <Grid item xs={12}>
        <LeaveAdminTabel />
      </Grid>
    </Grid>
  );
};

export default LeaveAdmin;
